module.exports = __webpack_public_path__ + "static/header-right-55fcc9f0646ef2f7395b91b678cf0513.png";